// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__nqZJ9","container":"Layout_container__nqBu4","header":"Layout_header__TyB9T","main":"Layout_main__FV28D","bgMedia":"Layout_bgMedia__xQoEC"};